import styled from "styled-components";

export const DefaultContainer = styled.div`
  width: 100%;
  display: content;
  grid-template-columns: 1fr;
  margin-top: 5px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: ${(props) => (props.isAdmin ? "space-between" : "flex-end")};
  align-content: space-between;
`;
